webpackJsonp([126511778744290],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/character--keoni-no-slippers@3x.13bb0f89.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/floor--wood@3x.19980ef7.png";

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f1@3x.3ddb018a.png";

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f2@3x.b5f62d7f.png";

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f3@3x.4a60013c.png";

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f4@3x.e80d2869.png";

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f5@3x.ff040d19.png";

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f6@3x.b15f2503.png";

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f7@3x.356867dd.png";

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f8@3x.d173a647.png";

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--ac--f9@3x.79d253a3.png";

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--blinds--f1@3x.8cdb7b7b.png";

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--blinds--f2@3x.4af24615.png";

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--blinds--f3@3x.859013c1.png";

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--blinds--f4@3x.b5487400.png";

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--blinds--f5@3x.fc3def08.png";

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f1@3x.be77af07.png";

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f2@3x.c77caf5a.png";

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f3@3x.07da2898.png";

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f4@3x.eb08b092.png";

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f5@3x.4ab82b22.png";

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f6@3x.38c90bd3.png";

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--chloe--f7@3x.07341e59.png";

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--entertainment-system@3x.07717d6b.png";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--plant@3x.65645c5e.png";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--power-strip@3x.dc8718a6.png";

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--rug@3x.d6ed88fe.png";

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--sofa-1@3x.4aac3da5.png";

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/item--sofa-2@3x.0519931e.png";

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/walls--green@3x.53a4c5a3.png";

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ConditionalWrapper = __webpack_require__(92);
	
	var _ConditionalWrapper2 = _interopRequireDefault(_ConditionalWrapper);
	
	var _DropChildrenMotion = __webpack_require__(93);
	
	var _DropChildrenMotion2 = _interopRequireDefault(_DropChildrenMotion);
	
	var _Item = __webpack_require__(13);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _AC = __webpack_require__(735);
	
	var _AC2 = _interopRequireDefault(_AC);
	
	var _Blinds = __webpack_require__(736);
	
	var _Blinds2 = _interopRequireDefault(_Blinds);
	
	var _EntertainmentSystem = __webpack_require__(742);
	
	var _EntertainmentSystem2 = _interopRequireDefault(_EntertainmentSystem);
	
	var _Plant = __webpack_require__(747);
	
	var _Plant2 = _interopRequireDefault(_Plant);
	
	var _PowerStrip = __webpack_require__(748);
	
	var _PowerStrip2 = _interopRequireDefault(_PowerStrip);
	
	var _Rug = __webpack_require__(752);
	
	var _Rug2 = _interopRequireDefault(_Rug);
	
	var _Chloe = __webpack_require__(740);
	
	var _Chloe2 = _interopRequireDefault(_Chloe);
	
	var _Sofa = __webpack_require__(754);
	
	var _Sofa2 = _interopRequireDefault(_Sofa);
	
	var _Sofa3 = __webpack_require__(755);
	
	var _Sofa4 = _interopRequireDefault(_Sofa3);
	
	var _wallsGreen3x = __webpack_require__(709);
	
	var _wallsGreen3x2 = _interopRequireDefault(_wallsGreen3x);
	
	var _floorWood3x = __webpack_require__(200);
	
	var _floorWood3x2 = _interopRequireDefault(_floorWood3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomLiving__Container'
	})(['position:relative;pointer-events:none;']);
	
	var RoomLiving = function (_Component) {
	  _inherits(RoomLiving, _Component);
	
	  function RoomLiving() {
	    _classCallCheck(this, RoomLiving);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RoomLiving.prototype.shouldAnimate = function shouldAnimate(id) {
	    var animateIds = this.props.animateIds;
	
	
	    return animateIds.includes(id);
	  };
	
	  RoomLiving.prototype.shouldShowHighlight = function shouldShowHighlight(id) {
	    var _props = this.props,
	        pending = _props.pendingHighlightIds,
	        success = _props.successHighlightIds;
	
	
	    return pending.includes(id) || success.includes(id);
	  };
	
	  RoomLiving.prototype.getHighlightType = function getHighlightType(id) {
	    var _props2 = this.props,
	        pending = _props2.pendingHighlightIds,
	        success = _props2.successHighlightIds;
	
	
	    if (pending.includes(id)) return 'pending';
	    if (success.includes(id)) return 'success';
	
	    return null;
	  };
	
	  RoomLiving.prototype.renderItem = function renderItem(item) {
	    var onItemClick = this.props.onItemClick;
	    var id = item.id,
	        Comp = item.component,
	        left = item.left,
	        bottom = item.bottom,
	        width = item.width,
	        _item$animate = item.animate,
	        animate = _item$animate === undefined ? false : _item$animate;
	
	
	    var isEntertainmentSystem = id === 'entertainmentSystem';
	    var hasBeenClickedBefore = !this.props.pendingHighlightIds.includes(id);
	    var shouldShowEasterEgg = isEntertainmentSystem && hasBeenClickedBefore;
	
	    var ItemComponent = shouldShowEasterEgg ? _Item.AnchorItem : _Item2.default;
	
	    return _react2.default.createElement(
	      ItemComponent,
	      {
	        left: left,
	        bottom: bottom,
	        width: width,
	        key: 'RoomLiving__Item--' + id,
	        href: shouldShowEasterEgg ? 'https://youtu.be/6DL37kDE01Q' : undefined,
	        target: shouldShowEasterEgg ? '_blank' : undefined
	      },
	      _react2.default.createElement(Comp, {
	        animate: this.shouldAnimate(id) || animate,
	        highlight: this.shouldShowHighlight(id),
	        highlightType: this.getHighlightType(id),
	        onClick: function onClick() {
	          return onItemClick(id);
	        }
	      })
	    );
	  };
	
	  RoomLiving.prototype.render = function render() {
	    var _props3 = this.props,
	        children = _props3.children,
	        dropChildrenMotion = _props3.dropChildrenMotion,
	        onItemClick = _props3.onItemClick,
	        props = _objectWithoutProperties(_props3, ['children', 'dropChildrenMotion', 'onItemClick']);
	
	    return _react2.default.createElement(
	      Container,
	      props,
	      _react2.default.createElement(_ItemImage2.default, { src: _wallsGreen3x2.default }),
	      _react2.default.createElement(
	        _Item2.default,
	        { left: -3.4, bottom: -0.5, width: 101.65 },
	        _react2.default.createElement(_ItemImage2.default, { src: _floorWood3x2.default })
	      ),
	      _react2.default.createElement(
	        _ConditionalWrapper2.default,
	        {
	          condition: dropChildrenMotion,
	          wrapper: _DropChildrenMotion2.default
	        },
	        RoomLiving.items.map(this.renderItem.bind(this)),
	        children
	      )
	    );
	  };
	
	  return RoomLiving;
	}(_react.Component);
	
	RoomLiving.propTypes = {
	  dropChildrenMotion: _propTypes2.default.bool,
	  onItemClick: _propTypes2.default.func,
	  pendingHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  successHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	RoomLiving.defaultProps = {
	  dropChildrenMotion: true,
	  onItemClick: function onItemClick(id) {
	    return console.log('clicked ' + id);
	  },
	  pendingHighlightIds: [],
	  successHighlightIds: []
	};
	RoomLiving.items = [{
	  id: 'blinds',
	  component: _Blinds2.default,
	  left: 57.25,
	  bottom: 29.5,
	  width: 33
	}, {
	  id: 'plant',
	  component: _Plant2.default,
	  left: 42,
	  bottom: 43,
	  width: 21
	}, {
	  id: 'entertainmentSystem',
	  component: _EntertainmentSystem2.default,
	  left: 10,
	  bottom: 25.2,
	  width: 40
	}, {
	  id: 'powerStrip',
	  component: _PowerStrip2.default,
	  left: 4.7,
	  bottom: 23.65,
	  width: 12.5
	}, {
	  id: 'rug',
	  component: _Rug2.default,
	  left: 21,
	  bottom: 5,
	  width: 70
	}, {
	  id: 'sofa1',
	  component: _Sofa2.default,
	  left: 39.5,
	  bottom: 17.18,
	  width: 47.4
	}, {
	  id: 'chloe',
	  component: _Chloe2.default,
	  left: 65.3,
	  bottom: 32.15,
	  width: 9.5,
	  animate: true
	}, {
	  id: 'sofa2',
	  component: _Sofa4.default,
	  left: 35.9,
	  bottom: 7.67,
	  width: 51.1
	}, {
	  id: 'ac',
	  component: _AC2.default,
	  left: 20.97,
	  bottom: 60.11,
	  width: 31,
	  animate: true
	}];
	exports.default = RoomLiving;
	module.exports = exports['default'];

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImageAnimated = __webpack_require__(11);
	
	var _ItemImageAnimated2 = _interopRequireDefault(_ItemImageAnimated);
	
	var _itemAcF13x = __webpack_require__(619);
	
	var _itemAcF13x2 = _interopRequireDefault(_itemAcF13x);
	
	var _itemAcF23x = __webpack_require__(620);
	
	var _itemAcF23x2 = _interopRequireDefault(_itemAcF23x);
	
	var _itemAcF33x = __webpack_require__(621);
	
	var _itemAcF33x2 = _interopRequireDefault(_itemAcF33x);
	
	var _itemAcF43x = __webpack_require__(622);
	
	var _itemAcF43x2 = _interopRequireDefault(_itemAcF43x);
	
	var _itemAcF53x = __webpack_require__(623);
	
	var _itemAcF53x2 = _interopRequireDefault(_itemAcF53x);
	
	var _itemAcF63x = __webpack_require__(624);
	
	var _itemAcF63x2 = _interopRequireDefault(_itemAcF63x);
	
	var _itemAcF73x = __webpack_require__(625);
	
	var _itemAcF73x2 = _interopRequireDefault(_itemAcF73x);
	
	var _itemAcF83x = __webpack_require__(626);
	
	var _itemAcF83x2 = _interopRequireDefault(_itemAcF83x);
	
	var _itemAcF93x = __webpack_require__(627);
	
	var _itemAcF93x2 = _interopRequireDefault(_itemAcF93x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var path = 'M84.34,0 L85.56,0.88 L85.56,79.34 L1.22,128.03 L0,127.15 L0,48.69 L84.34,0 Z';
	
	var frames = [_itemAcF13x2.default, _itemAcF23x2.default, _itemAcF33x2.default, _itemAcF43x2.default, _itemAcF53x2.default, _itemAcF63x2.default, _itemAcF73x2.default, _itemAcF83x2.default, _itemAcF93x2.default];
	
	var AC = function AC(_ref) {
	  var animate = _ref.animate,
	      props = _objectWithoutProperties(_ref, ['animate']);
	
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 168 157',
	      sparksTop: 46,
	      sparksLeft: 47
	    }, props),
	    _react2.default.createElement(_ItemImageAnimated2.default, { srcs: frames, fps: 6, animate: animate })
	  );
	};
	
	AC.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = AC;
	module.exports = exports['default'];

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImageAnimated = __webpack_require__(11);
	
	var _ItemImageAnimated2 = _interopRequireDefault(_ItemImageAnimated);
	
	var _itemBlindsF13x = __webpack_require__(628);
	
	var _itemBlindsF13x2 = _interopRequireDefault(_itemBlindsF13x);
	
	var _itemBlindsF23x = __webpack_require__(629);
	
	var _itemBlindsF23x2 = _interopRequireDefault(_itemBlindsF23x);
	
	var _itemBlindsF33x = __webpack_require__(630);
	
	var _itemBlindsF33x2 = _interopRequireDefault(_itemBlindsF33x);
	
	var _itemBlindsF43x = __webpack_require__(631);
	
	var _itemBlindsF43x2 = _interopRequireDefault(_itemBlindsF43x);
	
	var _itemBlindsF53x = __webpack_require__(632);
	
	var _itemBlindsF53x2 = _interopRequireDefault(_itemBlindsF53x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var points = '169.97 94.8 170 94.78 5.7 0 0 3.5 0 10.57 3.88 12.8 3.88 43.09 3.96 43.13 3.96 204.69 7.69 206.84 7.69 209.91 10.91 209.91 10.91 211.75 14.12 211.75 14.12 213.6 17.34 213.6 17.34 215.45 20.56 215.45 20.56 217.3 23.77 217.3 23.77 219.14 26.99 219.14 26.99 220.99 30.21 220.99 30.21 222.84 33.43 222.84 33.43 224.68 36.64 224.68 36.64 226.53 39.86 226.53 39.86 228.38 43.08 228.38 43.08 230.22 46.3 230.22 46.3 232.07 49.51 232.07 49.51 233.92 52.73 233.92 52.73 235.77 55.95 235.77 55.95 237.61 64.76 237.61 65.42 237.61 70.63 240.62 70.63 240.62 80.25 246.17 80.25 246.17 162.13 293.41 162.13 295.94 168.24 299.47 170 298.45 170 94.93 169.97 94.91 169.97 94.8';
	
	var frames = [_itemBlindsF13x2.default, _itemBlindsF23x2.default, _itemBlindsF33x2.default, _itemBlindsF43x2.default, _itemBlindsF53x2.default];
	
	var Blinds = function (_Component) {
	  _inherits(Blinds, _Component);
	
	  function Blinds(props) {
	    _classCallCheck(this, Blinds);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      animate: props.animate
	    };
	    return _this;
	  }
	
	  Blinds.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _state = this.state,
	        animate = _state.animate,
	        didAnimateOnce = _state.didAnimateOnce;
	
	
	    if (!animate && nextProps.animate) {
	      this.setState({ animate: true });
	    }
	  };
	
	  Blinds.prototype.render = function render() {
	    var animate = this.state.animate;
	
	
	    return _react2.default.createElement(
	      _IrregularInteraction2.default,
	      _extends({
	        points: points,
	        preserveAspectRatio: 'xMidYMin meet',
	        viewBox: '0 0 170 299.47',
	        sparksTop: 5,
	        sparksLeft: 100,
	        sparksRotation: 250
	      }, this.props),
	      _react2.default.createElement(_ItemImageAnimated2.default, {
	        srcs: frames,
	        fps: 6,
	        animate: animate,
	        onCompleteFrame: frames.length - 1,
	        loops: 1
	      })
	    );
	  };
	
	  return Blinds;
	}(_react.Component);
	
	Blinds.propTypes = _IrregularInteraction2.default.propTypes;
	exports.default = Blinds;
	module.exports = exports['default'];

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImageAnimated = __webpack_require__(11);
	
	var _ItemImageAnimated2 = _interopRequireDefault(_ItemImageAnimated);
	
	var _itemChloeF13x = __webpack_require__(635);
	
	var _itemChloeF13x2 = _interopRequireDefault(_itemChloeF13x);
	
	var _itemChloeF23x = __webpack_require__(636);
	
	var _itemChloeF23x2 = _interopRequireDefault(_itemChloeF23x);
	
	var _itemChloeF33x = __webpack_require__(637);
	
	var _itemChloeF33x2 = _interopRequireDefault(_itemChloeF33x);
	
	var _itemChloeF43x = __webpack_require__(638);
	
	var _itemChloeF43x2 = _interopRequireDefault(_itemChloeF43x);
	
	var _itemChloeF53x = __webpack_require__(639);
	
	var _itemChloeF53x2 = _interopRequireDefault(_itemChloeF53x);
	
	var _itemChloeF63x = __webpack_require__(640);
	
	var _itemChloeF63x2 = _interopRequireDefault(_itemChloeF63x);
	
	var _itemChloeF73x = __webpack_require__(641);
	
	var _itemChloeF73x2 = _interopRequireDefault(_itemChloeF73x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var path = 'M29.1702062,38.7937182 C29.3875286,38.538277 29.5943362,38.2734967 29.79,38 C28.611203,37.1686641 27.5309101,36.2057943 26.57,35.13 C24.8601188,32.9307819 22.7496913,31.0748271 20.35,29.66 C18.83,30.19 16.96,30.81 14.71,31.58 C11.34,32.75 7.84,33.65 5.34,35.44 C2.59,37.44 0.34,36.88 0.17,35.44 C8.8817842e-16,34 1.65,33.12 4.5,31.76 C7.35,30.4 10.04,28.04 12.16,27.34 C12.4207785,27.255953 12.6748348,27.1523247 12.92,27.03 C12.7961752,26.9336919 12.6772925,26.8352732 12.5631563,26.73495 C11.9080744,27.1159568 11.1069257,27.2195337 10.35,26.98 C9.37,26.68 6.69,25.46 6.08,23.68 C5.4330867,22.3325499 5.71887099,20.7224976 6.79,19.68 C7.1894192,19.2461334 7.60019617,18.8230383 8.02188289,18.4111468 C6.75162666,18.0959084 6.48623763,17.4629542 5.77,16.83 C5.66307822,16.735511 5.56326682,16.6470503 5.47239151,16.5607937 C5.34071297,16.615027 5.20989767,16.6714355 5.08,16.73 C4.41,17.04 3.76,17.38 3.08,17.73 C3.73,17.38 4.37,17.02 5.03,16.73 C5.16874145,16.6638306 5.30859741,16.6001316 5.44950097,16.5389282 C5.28310982,16.3789398 5.14824526,16.2254721 5.05669826,16.053826 C3.66970612,16.3339038 2.3110608,16.7475256 1,17.29 C2.29888187,16.7280152 3.64711369,16.2934702 5.02567693,15.991301 C4.9475019,15.8210889 4.91099448,15.6311863 4.92675559,15.3993871 C3.24233229,15.640254 1.58884133,16.0761132 -7.10542736e-15,16.7 C1.58806393,16.0521005 3.24370409,15.5924574 4.93306252,15.3285688 C4.94397233,15.2289241 4.96404431,15.1216998 4.99403338,15.0053145 C4.51302322,15.0409195 4.0341146,15.1058724 3.56,15.2 C2.53209468,15.3976015 1.52693098,15.6991507 0.56,16.1 C1.52326749,15.6651974 2.52850445,15.3301184 3.56,15.1 C4.04527659,14.9955984 4.53607136,14.9217509 5.0294962,14.8786881 C5.08860558,14.6825332 5.17359532,14.4616789 5.287524,14.2097182 C4.81266279,14.1445069 4.33102294,14.1275644 3.85,14.16 C2.81829061,14.2195004 1.80403375,14.4527795 0.85,14.85 C1.80119129,14.4361484 2.8154625,14.1859615 3.85,14.11 C4.34068452,14.0700115 4.83275217,14.0810623 5.31844027,14.1421173 C5.37815264,14.0129794 5.44521064,13.8758763 5.52,13.73 C6.53,11.76 4.91,10.84 6.84,7.94 C7.42910617,7.05481456 8.06572865,6.38764513 8.7527113,5.88787094 C8.67275968,5.01398582 8.36600043,1.27636127 8.92742896,0.873274136 C8.96151247,0.84449631 9.0048793,0.828452326 9.05,0.828452326 C9.10322768,0.828452326 9.15401463,0.850779602 9.19,0.89 C10.5258377,2.03401702 11.8029543,3.24479473 13.0164721,4.51768746 C13.4192446,4.49094195 13.8336628,4.48 14.26,4.48 C15.4391821,4.45854313 16.5902826,4.72046695 17.6246178,5.2257557 C18.7441183,4.52416939 19.85,4.48512455 19.85,6.75 C19.8478052,6.79709261 19.8454354,6.84417057 19.8428908,6.89123292 C19.8961231,6.94986655 19.9485018,7.00945966 20,7.07 C20.476735,7.62452939 20.8831456,8.23582467 21.21,8.89 C21.96,10.26 24.29,11.07 28.43,11.43 C33.5421103,11.8441952 38.4868018,13.4467683 42.87,16.11 C46.7,18.55 50.39,22.31 51,28 C51.1848014,29.8822363 51.1822143,31.5302369 51.0295137,32.9696536 C51.0234407,33.1159773 51.012902,33.2622784 50.9978749,33.4083521 C50.9985841,33.4055683 50.9992925,33.4027843 51,33.4 C50.75,35.48 51.46,38.82 48.95,42.35 C46.79,45.35 40.77,48.3 35.58,47.13 C35.0001102,46.9992734 34.4660369,46.8545646 33.9715869,46.6989284 C32.6843203,47.4524943 31.1557418,47.2149049 27.67,47.54 C23.81,47.9 22.54,48.25 22.33,47.08 C22.1825982,46.2587616 22.6411955,45.4128891 23.5259653,44.8951189 C23.3107185,44.9017188 23.0953905,44.9066798 22.88,44.91 C21.01,44.81 18.95,44.91 18.88,44.05 C18.81,43.19 18.71,41.56 20.81,41.56 C21.916615,41.56 23.1704038,41.640529 24.3094365,41.5703866 C21.9102219,40.8438367 19.6983052,40.5167446 20.07,38.59 C20.39,36.82 23.74,37.1 25.15,37.37 C26.9174664,37.705519 28.1644261,38.2097541 29.1702062,38.7937182 Z';
	
	var frames = [_itemChloeF13x2.default, _itemChloeF23x2.default, _itemChloeF33x2.default, _itemChloeF43x2.default, _itemChloeF53x2.default, _itemChloeF63x2.default, _itemChloeF73x2.default, _itemChloeF63x2.default, _itemChloeF53x2.default, _itemChloeF43x2.default, _itemChloeF33x2.default, _itemChloeF23x2.default, _itemChloeF13x2.default];
	
	var Chloe = function Chloe(_ref) {
	  var animate = _ref.animate,
	      props = _objectWithoutProperties(_ref, ['animate']);
	
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 52 48'
	    }, props),
	    _react2.default.createElement(_ItemImageAnimated2.default, { srcs: frames, fps: 5, animate: animate })
	  );
	};
	
	Chloe.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = Chloe;
	module.exports = exports['default'];

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemEntertainmentSystem3x = __webpack_require__(643);
	
	var _itemEntertainmentSystem3x2 = _interopRequireDefault(_itemEntertainmentSystem3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var points = '176.26 68.79 176.26 1.63 173.44 0 50.1 71.21 50.1 131.7 0 160.68 0 212.61 1.4 213.41 1.4 215.82 56.69 247.52 220.73 152.62 220.73 150.17 224.17 148.18 224.17 96.25 176.26 68.79';
	
	var tvPath = 'M176.26,1.63,173.44,0,50.1,71.21v79.46l2.82,1.63s15.8-7.67,34.45-17.5L104,144.39l43-24.84v-1.4l-15-8.68c22.56-13.86,44.27-28.39,44.27-28.39Z';
	
	var boxesPath = 'M159.8,136.49l-31.57,18.3-3.95,2.29-2.66,1.54-21.76,12.6v15.94l6.14,3.55h0l31.61-18.26v-4.58l4,2.31h0l4.15-2.39a2.57,2.57,0,0,0,.86-.33,4.38,4.38,0,0,0,.86-.66l25.75-14.87v-7.65Z';
	
	var EntertainmentSystem = function EntertainmentSystem(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      points: points,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 224.17 247.52',
	      sparksTop: -2,
	      sparksLeft: 0,
	      sparksRotation: 163
	    }, props, {
	      highlight: false
	    }),
	    _react2.default.createElement(_IrregularInteraction2.default, _extends({
	      path: tvPath,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 224.17 247.52',
	      sparksTop: -2,
	      sparksLeft: 0,
	      sparksRotation: 163
	    }, props)),
	    _react2.default.createElement(_IrregularInteraction2.default, _extends({
	      path: boxesPath,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 224.17 247.52',
	      sparksTop: -2,
	      sparksLeft: 0,
	      sparksRotation: 163
	    }, props)),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemEntertainmentSystem3x2.default })
	  );
	};
	
	EntertainmentSystem.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = EntertainmentSystem;
	module.exports = exports['default'];

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemPlant3x = __webpack_require__(655);
	
	var _itemPlant3x2 = _interopRequireDefault(_itemPlant3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'M51.0956143,140.960933 C51.0882124,140.900231 51.0807196,140.839539 51.0731359,140.778858 C50.7133503,139.140861 50.2920235,137.516755 49.81,135.91 C49.0239082,133.676793 48.3563117,131.403627 47.81,129.1 C48.2717315,129.52818 48.7071098,129.98171 49.1143688,130.458 C49.0275345,130.10065 48.9372088,129.744342 48.84,129.39 L47.84,126.01 C47.09,123.79 46.36,121.55 45.47,119.38 L44.83,117.74 L44.1,116.14 C43.6,115.08 43.1,113.99 42.61,112.94 C41.49,110.87 40.44,108.75 39.13,106.79 C37.6249377,104.264978 35.926479,101.875334 34.1813636,99.491166 C29.5669967,98.5058068 17.8649269,98.8325363 7.2,105.27 C7.43333333,104.923333 7.68333333,104.59 7.95,104.27 L6.8,104.45 C7.14,104.09 7.49666667,103.733333 7.87,103.38 L6.79,103.56 C7.14333333,103.186667 7.51666667,102.813333 7.91,102.44 L6.91,102.51 C7.37666667,102.09 7.86666667,101.673333 8.38,101.26 L7.27,101.31 C7.75,100.943333 8.24666667,100.583333 8.76,100.23 L8.12,99.71 C10.9538579,98.3639175 16.7490552,96.8471815 22.0172161,96.3545874 C21.3064803,96.1815616 20.5800086,96.0122211 19.84,95.85 C13.3270238,94.2990199 6.68620402,93.3450715 0,93 L1.64802183,92.2808632 C1.64534791,92.2805754 1.64267397,92.2802877 1.64,92.28 C1.64293715,92.2801728 1.64587423,92.2803457 1.64881121,92.2805187 L1.65,92.28 L0.8,91.71 L2.48,91.34 L1.7,90.61 L3.20630211,90.2808081 C3.20420146,90.2805387 3.20210076,90.2802693 3.2,90.28 C3.2024318,90.2801969 3.2048636,90.2803939 3.20729538,90.2805911 L3.21,90.28 L2.65,89.56 L4.21,89.3 L3.54,88.63 L5.23539912,88.3308119 C5.2335995,88.3305412 5.23179979,88.3302706 5.23,88.33 C5.2320575,88.330225 5.23411499,88.3304502 5.23617246,88.3306754 L5.24,88.33 L4.92,87.54 C10.0125639,88.1585585 14.7765655,89.4502993 19.0105755,90.9919608 C13.2439334,86.9454775 7.72260037,82.5666843 5.08,80.62 L7,80.52 L6.85,79.46 L8.44,79.77 L8.5,78.54 L9.92,78.77 L10.12,77.66 L11.52,78 L11.59,76.94 L13.13,77.28 L13.55,76.18 C16.9987313,79.2362238 20.3646881,82.7382679 23.4641446,86.1327412 C20.1412708,81.1515771 17.2059126,76.2094486 15.69,73.86 L17.45,74.31 L17.75,73.31 L19.07,74.08 L19.59,73 L20.77,73.75 L20.7841607,73.7281787 C20.7827739,73.7254524 20.781387,73.7227261 20.78,73.72 C20.781547,73.7224797 20.7830937,73.7249596 20.7846402,73.7274396 L21.38,72.81 L22.52,73.55 L23,72.55 L24.28,73.33 L25.08,72.47 C28.4186811,78.9338418 31.0330987,86.477799 33.1589178,92.3930795 C32.7994276,90.43625 32.6253383,88.2554891 32.79,86.06 C32.8914589,83.132186 33.56947,80.1740272 34.4349599,77.6636892 L33.9,76.55 L32.7,74.33 C32.1047391,73.2072927 31.5151557,72.0732302 30.9398058,70.9406467 C30.7540073,70.7904873 30.5658894,70.622737 30.3757436,70.4385935 C30.1089228,70.2778076 29.8332931,70.1313614 29.55,70 C29.5346722,69.9927083 29.5193338,69.9854403 29.5039848,69.978196 C24.8180833,68.025927 14.0125538,66.9718473 5.15,72.59 C5.31,72.2233333 5.49,71.8566667 5.69,71.49 L4.62,71.49 C4.87333333,71.1633333 5.14666667,70.8166667 5.44,70.45 L4.44,70.45 C4.70666667,70.07 4.99,69.6933333 5.29,69.32 L4.29,69.24 C4.65,68.8266667 5.03,68.42 5.43,68.02 L4.36,67.91 C4.74,67.5566667 5.13666667,67.2233333 5.55,66.91 L4.83,66.26 C8.29,64.64 17.32,63.26 23.25,65.07 C23.7729493,65.2005281 24.270065,65.3449182 24.7417454,65.5006104 C19.024321,62.1993058 11.1591589,59.6121421 3.84,60.73 C4.01333333,60.2033333 4.19666667,59.6833333 4.39,59.17 L3.19,58.17 C3.46333333,57.75 3.75,57.34 4.05,56.94 L2.94,56 C3.22,55.5466667 3.51,55.1033333 3.81,54.67 L2.81,53.62 C3.18333333,53.1866667 3.56666667,52.7666667 3.96,52.36 L2.82,51.16 C3.20666667,50.8533333 3.6,50.5566667 4,50.27 C3.69333333,49.6433333 3.41,49.0133333 3.15,48.38 C6.69,48.79 15.24,51.99 21.42,57.16 C21.9591165,57.5748342 22.4815909,58.0034897 22.9865586,58.4422478 C20.0828821,52.4227761 17.5210223,46.0361196 16.25,43.18 L17.78,43.86 L18.18,42.86 L19.31,43.77 L19.92,42.77 L20.92,43.57 L21.59,42.7 L22.59,43.56 L23.15,42.64 L24.23,43.55 L25.07,42.78 C27.4150472,49.690335 28.9445857,57.6362365 30.214144,63.8117198 C30.1513605,61.9511916 30.2716328,59.9255958 30.67,57.9 C31.58,51.9 34.94,46 36.82,44.08 C37,44.5866667 37.1666667,45.09 37.32,45.59 C37.7066667,45.59 38.0966667,45.59 38.49,45.59 C38.49,46.01 38.49,46.43 38.49,46.85 C38.9366667,46.9033333 39.3866667,46.9766667 39.84,47.07 C39.8,47.4433333 39.78,47.8166667 39.78,48.19 C40.1866667,48.31 40.5933333,48.4433333 41,48.59 L40.84,49.66 C41.2266667,49.76 41.6133333,49.8733333 42,50 L41.82,51.17 C42.2133333,51.3833333 42.6,51.61 42.98,51.85 C35.7561242,55.8642803 32.0691806,65.2215857 31.9268149,70.3033537 C31.928056,70.4060994 31.9303404,70.5088357 31.933668,70.6115466 C31.9414492,70.6372149 31.9490254,70.6626791 31.9563961,70.6879366 C32.0924744,68.6218435 33.760429,64.7540862 37.58,62.58 C40.077309,60.8217514 43.5657254,60.640749 46.5758688,61.2895991 C46.4119373,60.435253 46.2414123,59.5818488 46.06,58.73 L45.39,55.49 L44.65,52.27 C44.18,50.11 43.57,48 43.01,45.87 C42.7170534,44.9087691 42.4073456,43.9559189 42.0962208,42.9807608 C34.7012418,42.7197619 8.18827072,23.0415514 0.27,17.58 L2.28,17.44 L1.64,16 L3.52,16.42 L3,14.77 L4.69,15.15 L4.68945965,15.1473854 C4.6863066,15.1449235 4.68315338,15.1424617 4.68,15.14 C4.68310123,15.1422096 4.68620236,15.1444194 4.68930338,15.1466293 L4.38,13.65 L6.07,14.11 L5.62,12.62 L7.45,13.07 L7.39,11.59 C16.6406119,18.9119913 26.2667305,28.1206749 33.6931802,35.051146 C26.5681534,26.5262183 18.1037321,13.5448494 14.76,8.77 L16.64,9.23 L16.64,7.82 L18.17,8.74 L18.38,7.19 L19.75,8 L20.09,6.73 L21.43,7.63 L21.64,6.24 L23.11,7.17 L23.1251432,7.13503291 C23.1200993,7.12668796 23.1150516,7.11834366 23.11,7.11 C23.1152552,7.11786892 23.1205083,7.12573915 23.1257592,7.13361069 L23.66,5.9 C26.0561929,9.90073214 28.3649854,14.2492255 30.5305674,18.5573198 C28.2450148,11.4061979 26.3901835,4.619901 25.34,1.24 L27.31,2.41 L28,1.14 L29.44,2.55 L30.44,1.23 L31.7,2.49 L32.75,1.4 L33.94,2.72 L34.85,1.54 L36.17,3 L37.44,2 C38.6094356,7.55574156 39.3801203,13.5211215 39.961913,19.2263986 C40.3502312,11.3257588 41.1292719,3.68970524 41.37,0 L42.8,1.73 L43.87,0.82 L44.63,2.57 L46,1.72 L46.71,3.28 L48.05,2.65 L48.66,4.24 L49.9,3.49 L50.62,5.21 L50.8367516,5.14995394 C50.8378363,5.14330297 50.8389191,5.13665166 50.84,5.13 C50.8391893,5.13657627 50.8383778,5.14315242 50.8375655,5.14972847 L52.1,4.8 C51.3843182,9.22449061 50.3274514,13.8080783 49.1658935,18.2557034 C49.8550218,20.1330287 50.5330619,22.0775939 51.1975179,24.058588 C51.8688895,23.2635235 52.573153,22.4966523 53.296125,21.7629489 C52.7858711,18.2380491 52.3665378,15.2594555 52.06,13.29 L53.36,14.06 L53.84,12.21 L54.73,13.56 L55.42,11.56 L56.22,12.75 L56.94,11 L57.68,12.35 L58.31,10.54 L59.15,11.9 L60.01,10.29 C60.1839452,12.0900847 60.3382296,13.9375925 60.475868,15.8144837 C62.1181747,14.7157013 63.6062116,13.8934402 64.7521073,13.4135913 C64.8923069,12.1551162 65.044471,10.9121112 65.21,9.69 L66.5,11.2 L67.74,9.73 L68.69,11.46 L69.79,10.06 L70.87,11.72 L72,10.42 L73,12.35 L74.31,10.89 L75.05,12.68 L77.06,11.7 C76.3244496,15.0282822 75.1469085,21.1957179 73.6601048,28.0587481 C73.9811878,28.524276 74.3145185,29.042939 74.6533958,29.607866 C76.7909585,24.3219687 79.0515467,19.0223318 81.37,14.19 L81.85,16 L83.24,15.05 L83.36,17.05 L84.63,16.12 L84.87,18.05 L86.16,17.25 L86.28,19.42 L87.72,18.51 L87.67,20.44 L89.41,20.2 C87.3434932,23.8174348 83.2827544,31.3952211 78.8333425,39.0225711 C78.9932031,39.5359644 79.1442055,40.0555346 79.2848043,40.579697 C81.1633873,38.333885 83.0908383,36.0637572 85.0284645,33.8430256 C85.7765016,31.0198623 86.5977102,28.2214051 87.51,25.54 L88.63,26.54 L90.07,25.33 L90.82,26.56 L92.11,25.42 L93.01,26.58 L94.37,25.51 L95.18,26.88 L96.69,25.68 L97.21,27 L99.29,26.1 C97.7884378,29.4493059 94.9405299,36.4537813 91.6213916,43.5578647 C94.910952,38.5997415 98.5137298,33.4590158 102.29,28.9 L102.98,30.3 L104.82,29.64 L105.07,31.1 L106.74,30.45 L107.157785,31.8923525 C107.158523,31.8915683 107.159262,31.8907842 107.16,31.89 C107.15928,31.8908467 107.158559,31.8916933 107.157839,31.89254 L107.16,31.9 L108.87,31.34 L109.13,32.96 L111.04,32.33 L111.04,33.77 L113.4,33.64 C110.432731,36.6214895 104.248037,43.2922321 97.7256684,49.5189787 C102.741109,46.8390307 108.468498,44.4177538 114.72,42.87 L114.46,43.97 L116.6,44.13 L115.88,45.13 L117.88,45.26 L117.3,46.26 L119.22,46.49 L118.37,47.57 L120.49,47.83 L119.49,48.71 L121.6,49.42 C113.404123,50.8090263 105.365216,53.0029781 97.6,55.97 C96.7322429,56.2818042 95.8816951,56.6009152 95.0504116,56.9227892 C101.59722,56.8513346 108.951469,58.0656477 112.65,59.48 C112.43,59.72 112.21,59.97 111.99,60.23 C112.656667,60.63 113.323333,61.04 113.99,61.46 L112.62,61.55 C113.286667,62.03 113.953333,62.5166667 114.62,63.01 L113.38,63.01 C113.92,63.45 114.44,63.8966667 114.94,64.35 L113.58,64.26 C114.093333,64.6733333 114.586667,65.0966667 115.06,65.53 L113.62,65.45 C114.006667,65.8766667 114.37,66.3066667 114.71,66.74 C100.124791,59.4258071 85.1741878,60.9183689 80.0776024,62.9687456 C79.6207167,63.1808287 79.1822252,63.4309948 78.766817,63.7167038 C78.0266934,65.398201 77.3392575,67.1025626 76.7055431,68.8273007 C80.1204903,66.7711728 83.5269523,65.3789756 85.6,64.93 C85.5807458,65.4883732 85.5367764,66.0714615 85.468092,66.6792649 C85.4820593,66.676168 85.4960286,66.6730797 85.51,66.67 C85.4958854,66.6743426 85.4817733,66.6786928 85.4676639,66.6830507 C85.4651425,66.7053339 85.4625879,66.7276504 85.46,66.75 C86.02,66.9433333 86.5766667,67.15 87.13,67.37 L86.3839918,68.5536663 C86.4093229,68.5490855 86.434659,68.54453 86.46,68.54 C86.434066,68.5470102 86.4081385,68.5540424 86.3822175,68.5610966 C86.9881288,68.8607636 87.5873896,69.1737313 88.18,69.5 L87.5055311,70.463527 C87.5136871,70.4623485 87.5218434,70.4611728 87.53,70.46 C87.5213556,70.4618702 87.5127117,70.4637424 87.5040683,70.4656168 L87.48,70.5 C87.9933333,70.8066667 88.5,71.14 89,71.5 L88.2,72.45 C88.6933333,72.79 89.1833333,73.1233333 89.67,73.45 L88.78,74.45 C89.2133333,74.87 89.6366667,75.2966667 90.05,75.73 C83.4638831,75.715525 77.4318437,77.6589458 72.7581546,80.2033328 C72.69163,80.405324 72.625541,80.607525 72.56,80.81 C72.428722,81.2137527 72.2983291,81.6177778 72.1688154,82.0220753 C73.0711267,81.6735772 74.0212283,81.364167 75.01,81.11 C81.22,79.21 89.04,79.63 92.09,80.51 L91.04,81.69 C91.32,82.0433333 91.59,82.4033333 91.85,82.77 L90.65,83.31 C90.8833333,83.77 91.12,84.22 91.36,84.66 L90.28,85.12 C90.4466667,85.5466667 90.6033333,85.9833333 90.75,86.43 L89.64,86.76 C89.8133333,87.1666667 89.9733333,87.58 90.12,88 L88.91,88.39 C88.9766667,88.85 89.03,89.3133333 89.07,89.78 C83.234398,86.4963209 76.2303804,85.8217254 70.806321,86.3913272 C70.795047,86.4284817 70.7837802,86.4656384 70.7725206,86.5027974 C70.9877482,86.517539 71.2069314,86.5365191 71.43,86.56 C76.61,86.84 83.22,90.5 85.43,92.73 L84.66,93 C84.8866667,93.38 85.09,93.7666667 85.27,94.16 L84.4,93.94 C84.5933333,94.3666667 84.7666667,94.79 84.92,95.21 L84.15,94.99 C84.1533565,94.993402 84.1566786,94.9967006 84.16,95 C84.1567656,94.9969718 84.1535306,94.9939443 84.1502949,94.9909176 C84.2701748,95.3639396 84.3767431,95.7336337 84.47,96.1 L83.69,95.79 C83.81,96.1433333 83.9166667,96.4933333 84.01,96.84 L83.18,96.53 C83.24,96.87 83.27,97.2033333 83.27,97.53 C79.6492875,92.7653026 74.3174477,90.2155826 69.980552,89.160344 C68.7533608,93.3481324 67.6153327,97.5646844 66.56,101.81 C64.8,108.89 63.24,116 62,123.1 C61.4106078,126.393096 60.9002929,129.699291 60.469415,133.015728 C61.1848479,132.031636 62.0131674,131.129894 62.94,130.33 C62.3711612,132.550206 61.6596838,134.731402 60.81,136.86 C60.3783843,138.119209 59.9808723,139.390178 59.6174639,140.672907 C59.58452,141.028374 59.5524841,141.383934 59.5213567,141.739581 C59.8683625,140.768148 60.2548636,139.810817 60.68,138.87 C61.4608232,136.90366 62.7476361,135.17871 64.41,133.87 C63.68,135.87 63.03,137.64 62.41,139.52 C61.8371607,141.405057 61.3895187,143.325909 61.07,145.27 C61.0492208,145.392786 61.0286398,145.515612 61.0082696,145.638478 C61.1717519,145.226723 61.3490793,144.820329 61.54,144.42 C62.0550716,143.127826 63.0166598,142.063338 64.25,141.42 C63.92,142.79 63.6,143.88 63.25,145.05 C63.1200308,145.588596 63.008932,146.131367 62.9168648,146.677316 C70.393589,148.393187 75.59,152.18635 75.59,156.59 C75.59,156.600003 75.5899732,156.610003 75.5899196,156.62 L75.59,163.86 C75.5855054,165.208382 75.0931447,166.499695 74.1967923,167.691491 L72.18,186.66 C72.16,191.71 64.01,195.81 53.95,195.81 C43.89,195.81 35.72,191.72 35.72,186.66 L33.7078069,167.734748 C32.7918239,166.530964 32.29,165.224712 32.29,163.86 L32.29,156.62 C32.2900268,156.610003 32.29,156.600003 32.29,156.59 C32.29,151.709599 38.6724735,147.579026 47.4679701,146.194925 C47.0687141,145.196616 46.6892557,144.197801 46.25,142.9 C47.4977245,143.331739 48.5345001,144.221936 49.15,145.39 C49.2585795,145.56904 49.3637289,145.750028 49.4654019,145.932863 C49.617674,145.916768 49.7705351,145.901478 49.9239668,145.887001 C49.9127789,145.807968 49.9014564,145.728967 49.89,145.65 C49.6282803,143.739101 49.2238158,141.850486 48.68,140 C48.09,138.15 47.46,136.38 46.68,134.44 C48.3650585,135.686688 49.6619189,137.385783 50.42,139.34 C50.6592821,139.874606 50.8845506,140.415103 51.0956143,140.960933 Z M58.5946942,144.712425 C58.6080744,144.662379 58.6215562,144.612361 58.6351396,144.562374 L58.6291299,144.561937 C58.617622,144.612089 58.6061431,144.662252 58.5946942,144.712425 Z M62.8277017,88.3151957 C62.620747,87.8204175 62.3658716,87.3467654 62.0665691,86.9010706 C61.576972,86.2628699 60.9263997,85.6195581 60.1377881,85.0407606 C59.8086142,88.4653898 59.5164963,91.8913249 59.26,95.32 C58.9183445,99.8870279 58.6009973,104.463779 58.3282973,109.040084 C58.7500025,106.589537 59.2006356,104.143598 59.67,101.7 C60.512115,97.1910375 61.5658758,92.7245038 62.8277017,88.3151957 Z M62.8453298,88.2536475 C62.8484788,88.2426618 62.8516291,88.2316765 62.8547807,88.2206916 C62.8207537,88.139811 62.7834671,88.057932 62.742978,87.9752282 C62.7785399,88.067421 62.8126635,88.1602381 62.8453298,88.2536475 Z M58.8168315,78.6105936 C58.9017926,78.0535463 58.9876956,77.4962046 59.0745407,76.9384943 C57.3052774,74.2076614 55.0038903,71.6709724 52.2368262,69.98 L51.83,69.98 C52.0966667,70.52 52.35,71.07 52.59,71.63 L51.78,71.63 C51.9733333,72.1966667 52.1533333,72.7633333 52.32,73.33 C51.5763139,72.4586601 50.8261841,71.696522 50.0749958,71.0333575 C50.3992388,72.7140088 50.7111506,74.3970044 51.0113056,76.082129 C53.8104749,75.9907183 56.7940481,76.6937803 58.8168315,78.6105936 Z M58.0467022,83.8351122 C57.0343355,83.3900225 55.8964622,83.0692041 54.65758,82.9470238 L54.37,83.18 C54.9233333,83.2866667 55.4666667,83.41 56,83.55 C54.725078,83.7552633 53.5213129,84.0169036 52.3858388,84.325558 C52.7396159,86.5973383 53.0738724,88.8723263 53.39,91.15 C54.1469719,96.6039204 54.7845995,102.07709 55.2837734,107.56712 C55.6665977,103.393433 56.085046,99.2226901 56.58,95.06 C57.0263337,91.3062191 57.5152344,87.5720846 58.0467022,83.8351122 Z M60.6041695,80.4242653 C61.0606356,80.9960551 61.4499728,81.5925036 61.778415,82.1938415 C61.4613925,81.3883736 61.0938495,80.5636888 60.6775202,79.7367918 C60.6529008,79.965947 60.6284507,80.1951047 60.6041695,80.4242653 Z M43.5530607,82.4488119 L43.44,82.41 C43.86,81.79 44.2966667,81.19 44.75,80.61 L44.02,80.3 C44.4333333,79.7933333 44.8566667,79.3033333 45.29,78.83 C45.2166667,78.4766667 45.1366667,78.11 45.05,77.73 C46.0669261,77.0531288 47.4960561,76.5367339 49.0887388,76.2718515 C48.7567274,73.9985706 48.4036693,71.7286028 48.0283284,69.4628308 C41.2537701,65.0133859 34.7932567,67.9069508 32.6367028,70.5651717 C32.4746271,70.7789127 32.3235178,71.0009758 32.1840183,71.2305149 C32.1651847,71.265024 32.1471919,71.2993742 32.1300495,71.3335471 C32.1538997,71.4078369 32.1772086,71.4823183 32.1999736,71.5569858 C32.7123757,72.2818324 33.2156801,73.0109162 33.7,73.74 L35.1227446,75.8492438 C35.8864919,74.0102112 36.7094761,72.5504057 37.38,71.73 C37.6333333,72.21 37.88,72.68 38.12,73.14 C38.52,73.08 38.9233333,73.0333333 39.33,73 L39.38,74.28 C39.8533333,74.2866667 40.33,74.31 40.81,74.35 L40.9,75.46 C40.9312856,75.4652945 40.9625885,75.4706585 40.9939088,75.4760919 C40.9959389,75.474061 40.9979693,75.4720303 41,75.47 C40.9983136,75.4720902 40.9966276,75.4741806 40.9949417,75.4762712 C41.3970967,75.5460562 41.8021161,75.6272991 42.21,75.72 C42.21,76.08 42.21,76.44 42.21,76.8 C42.6233333,76.86 43.04,76.93 43.46,77.01 C43.46,77.4033333 43.46,77.7966667 43.46,78.19 C43.8866667,78.3633333 44.3133333,78.5466667 44.74,78.74 C42.6686572,80.1545091 40.9820892,82.0057894 39.6483089,84.0409826 C39.8318068,84.4222826 40.0144793,84.8039953 40.1966327,85.1859675 C41.2528508,84.1926776 42.4016968,83.2616568 43.5530607,82.4488119 Z M63.4466846,88.8251169 L61.5,102 C60.78,107.06 60.18,112.13 59.67,117.21 C59.6149606,117.758235 59.560853,118.306587 59.5076771,118.855056 C60.8390904,112.89264 62.3365314,106.980955 64,101.12 C65.180902,96.9868429 66.4559348,92.8536857 67.8189229,88.7411136 C65.902601,88.4682801 64.3388432,88.5245958 63.4466846,88.8251169 Z M69.748222,83.1002752 C69.9114449,82.6374968 70.0757579,82.1751028 70.2411522,81.7131231 C67.8790284,83.2722329 66.0120463,84.9435487 64.7909965,86.4726645 C65.9581223,85.3760774 67.6635393,84.158047 69.748222,83.1002752 Z M74.9262814,69.9613669 C75.8993903,67.6545819 77.0150675,65.4118012 78.2664432,63.2459018 C78.2762998,63.1356707 78.29956,63.0193949 78.3367359,62.8980315 C78.320516,62.8385588 78.3042962,62.7790861 78.2880764,62.7196133 C78.0429665,62.1906518 77.7383987,61.690858 77.38,61.23 C77.3517537,61.19192 77.3233387,61.1539705 77.2947559,61.1161526 C76.0318812,59.625553 73.8101556,57.7501314 70.9446119,56.0994562 C67.5317233,58.7589414 64.6550971,60.6125333 63.001707,60.8549905 C62.5985411,63.9695853 62.1893361,67.0789544 61.7979127,70.1906769 C62.2954433,71.44987 62.7266318,72.7620344 63.05,74.09 C63.9019224,77.0644262 64.2016658,80.1241677 64.1695833,82.698152 C65.0987082,80.210393 66.7164133,77.4069056 69.14,74.93 C70.7598503,73.0762489 72.7989497,71.3967788 74.9262814,69.9613669 Z M60.6700697,67.6375352 C61.1381333,65.2674831 61.6547523,62.907164 62.2196147,60.5580688 C62.2163866,60.5557078 62.2131586,60.5533299 62.2099306,60.5509351 C59.8697718,59.7719453 55.8344605,52.318005 51.9289772,44.0262028 C51.7075237,43.9993178 51.4845331,43.973906 51.26,43.95 C51.4405982,43.8871832 51.6226415,43.8255225 51.8061298,43.7650178 C51.3005684,42.6886533 50.7975071,41.5992552 50.3009135,40.5095135 C47.635858,40.8381871 45.4182414,41.464971 44.0148104,42.1318343 C43.6467641,42.3276568 43.2946062,42.5519399 42.9615533,42.8026222 C43.293951,43.6993889 43.5954331,44.6589318 43.92,45.58 C44.55,47.71 45.24,49.83 45.77,51.98 L46.62,55.2 L47.39,58.44 C47.6583776,59.5287014 47.9113703,60.622531 48.1541719,61.7188921 C49.5399041,62.1783376 50.7419262,62.809266 51.58,63.52 C51.44,63.84 51.3166667,64.1633333 51.21,64.49 C51.5766667,64.9966667 51.93,65.5166667 52.27,66.05 L51.49,66.24 C51.6102484,66.4492322 51.7304968,66.6641038 51.8507452,66.8846145 C52.0549196,66.792052 52.2580045,66.7038472 52.46,66.62 L52.19,65.52 C52.5633333,65.3266667 52.9366667,65.1433333 53.31,64.97 L53.14,63.81 C53.56,63.6633333 53.9833333,63.5366667 54.41,63.43 L54.24,62.12 C54.6133333,62.0666667 54.9866667,62.0266667 55.36,62 C55.4866667,61.44 55.61,60.8866667 55.73,60.34 C56.9970993,61.4613829 58.9947197,64.2083758 60.6700697,67.6375352 Z M32.113179,71.367685 C32.1176351,71.3960809 32.1217031,71.4240503 32.1253813,71.4515867 C32.1487851,71.4846193 32.172171,71.517661 32.195538,71.5507116 C32.1710274,71.4843839 32.146096,71.4182273 32.1207459,71.3522456 C32.1182042,71.3573962 32.1156819,71.3625427 32.113179,71.367685 Z M80.6850561,53.1965355 C81.1185784,51.1055053 81.5749333,48.8682102 82.0657241,46.5444798 C81.5730976,46.9938715 81.0779774,47.4432054 80.5818609,47.8907265 C80.749589,49.7225859 80.77054,51.5156012 80.6850561,53.1965355 Z M79.2204999,63.3683894 C79.0781089,63.4701188 78.9368523,63.5636423 78.7968072,63.6486464 C78.7913103,63.6611064 78.7858163,63.6735676 78.7803252,63.6860301 C78.9288487,63.5742507 79.0797877,63.4660591 79.2330069,63.3615184 C79.2288253,63.3638087 79.2246563,63.366099 79.2204999,63.3683894 Z M78.3499177,62.8565578 C78.3388259,62.8313425 78.3276004,62.8061904 78.3162418,62.7811025 C78.3250357,62.8143888 78.3336155,62.8477451 78.3419804,62.8811693 C78.3445632,62.8729881 78.347209,62.8647842 78.3499177,62.8565578 Z M78.3540873,62.8440254 C78.3594757,62.8279942 78.3651025,62.8118787 78.3709687,62.795681 C78.3707311,62.7942841 78.3704926,62.7928874 78.3702532,62.7914908 L78.353012,62.8412987 C78.3533705,62.8422076 78.353729,62.8431165 78.3540873,62.8440255 Z M78.3526394,62.8403546 C78.3580209,62.8205963 78.3632565,62.8008036 78.368346,62.7809783 C78.3294863,62.6733164 78.2790148,62.5587844 78.2172755,62.438048 C78.2432011,62.5208505 78.2677837,62.6041418 78.2910066,62.6878908 C78.3119628,62.7385205 78.3325081,62.7893433 78.3526394,62.8403546 Z M78.0248103,62.0996561 C78.0859663,62.2238783 78.1445626,62.3494581 78.2005494,62.4763195 C78.1666537,62.3929452 78.129782,62.3107856 78.09,62.23 C78.0750498,62.1970236 78.0598533,62.1641645 78.044412,62.1314255 C78.03795,62.1208727 78.0314161,62.1102828 78.0248103,62.0996561 Z M73.4287336,54.103017 C73.4972196,54.1608352 73.5649631,54.2188838 73.6319347,54.2771561 C73.5716102,54.2135263 73.5106833,54.1498575 73.4491522,54.0861604 C73.4423447,54.0917814 73.4355385,54.0974003 73.4287336,54.103017 Z M61.7851196,48.1287406 C62.1139067,48.2237837 62.4559841,48.3299131 62.8086491,48.4465217 C62.8270942,47.9396233 62.8452756,47.4247931 62.8633416,46.9026057 C62.4952626,46.7450042 62.1200735,46.5916309 61.7377146,46.4428479 C61.7534832,47.0133595 61.7692436,47.5755702 61.7851196,48.1287406 Z M61.9273556,52.6440865 C62.0117048,55.0241238 62.1069004,57.1464654 62.2266574,58.9290451 C62.3932315,57.1891633 62.5212869,55.1190622 62.6307224,52.7958023 C62.3977382,52.7423069 62.1632568,52.691685 61.9273556,52.6440865 Z M45.7852633,30.2744379 C45.2659521,32.0505659 44.7710546,33.7416617 44.3224757,35.3203956 C44.8379902,34.0203303 45.4684112,32.650387 46.2142563,31.2688804 C46.0690994,30.9329471 45.926049,30.6012977 45.7852632,30.2744381 Z M42.9552306,42.7855822 C43.060113,42.6995085 43.1666143,42.6155982 43.2746645,42.5338903 C43.1536728,42.610387 43.0441602,42.6867359 42.9466663,42.7625574 C42.9495234,42.7702277 42.9523782,42.7779026 42.9552306,42.7855822 Z M55.1981765,36.7938206 C55.3367876,36.7839607 55.4756848,36.7749794 55.6147844,36.7668556 C55.5642011,36.4677573 55.5139443,36.1684683 55.4640219,35.8691599 C55.2945852,35.9104114 55.1264033,35.9526397 54.9595017,35.9958004 C55.0393891,36.2622638 55.1189493,36.5282947 55.1981765,36.7938206 Z M61.4709976,36.8841923 C62.0717118,36.9413436 62.6504545,37.0108341 63.1985441,37.0904908 C63.2262049,36.3436522 63.2550785,35.5903856 63.2854679,34.8318648 C62.6510056,34.8477513 62.0256008,34.8797991 61.4100689,34.9265848 C61.4311445,35.5831756 61.4514107,36.2359709 61.4709976,36.8841923 Z M53.5783498,31.4612553 C53.9414969,31.3196822 54.3114935,31.1837003 54.6870181,31.0532901 C54.6518851,30.8287216 54.6169719,30.6046783 54.5822821,30.381236 C54.2050495,30.617057 53.8335071,30.8589388 53.4680883,31.1060614 C53.5048988,31.22446 53.5416528,31.3428601 53.5783498,31.4612553 Z M61.213373,29.3954338 C62.0019546,29.257577 62.783428,29.141365 63.5473737,29.0466446 C63.5911484,28.1935318 63.6376629,27.3376355 63.6873176,26.4805062 C62.8217782,26.6817773 61.965985,26.9304234 61.1232932,27.2201007 C61.154786,27.9464635 61.1847584,28.6718989 61.213373,29.3954338 Z M38.621851,86.7947688 C38.5409843,86.6062943 38.4600408,86.417743 38.3789841,86.2290785 C38.0497401,86.872512 37.7515886,87.5246496 37.4836512,88.1785482 C37.8312178,87.7141115 38.2131345,87.2512903 38.621851,86.7947688 Z M48.1923203,118.220869 C47.4355891,114.461455 46.561096,110.725989 45.57,107.02 C45.11,105.41 44.73,103.77 44.22,102.18 L42.7,97.39 C42.3016802,96.1403692 41.8301615,94.921238 41.3759626,93.6944932 C39.0379142,95.2742989 37.3265335,96.9942677 36.4903808,98.2488887 C36.2852636,98.5878648 36.1174282,98.9480765 35.9898272,99.3232277 C37.8111742,101.293296 39.4861568,103.397705 41,105.62 C42.45,107.62 43.64,109.69 44.91,111.76 C45.52,112.81 46.05,113.91 46.62,114.98 L47.46,116.6 L48.1923203,118.220869 Z M43.4509702,92.4305648 C44.0114846,93.7999075 44.606041,95.1610793 45.11,96.56 L46.83,101.38 C47.42,102.98 47.83,104.63 48.39,106.25 C50.2552231,112.39954 51.7731391,118.648781 52.9366661,124.968114 C52.9208898,122.58179 52.868673,120.195474 52.78,117.81 C52.5333333,109.003333 51.94,100.21 51,91.43 C50.9428297,90.8966128 50.8846606,90.3632997 50.825477,89.8300717 C48.0930992,90.2892821 45.5919786,91.2607467 43.4509702,92.4305648 Z M42.3754428,89.8640449 C45.015738,88.1518748 47.9685206,86.8572816 49.66,86.48 L49.48,87.1 L50.5134265,87.1 C50.4304232,86.3944552 50.3455944,85.6890934 50.2589038,84.9839407 C46.9265867,86.1470387 44.2659428,87.7240067 42.184834,89.4138142 C42.1899031,89.4258692 42.1949586,89.4379311 42.2,89.45 L42.3754428,89.8640449 Z M40.4708617,91.2246363 L40.3973716,91.025284 C39.9588452,91.4647711 39.5558181,91.9054554 39.1867822,92.3424097 C39.5812869,91.9614059 40.0130281,91.5876352 40.4708617,91.2246363 Z M50.6347569,88.1427185 C50.6342571,88.1383753 50.6337572,88.134032 50.6332572,88.1296888 L50.62,88.14 C50.6249212,88.1409039 50.6298402,88.1418101 50.6347569,88.1427185 Z M50.5770648,87.6440434 C50.5581768,87.4816389 50.5391925,87.3192438 50.5201116,87.1568583 L50,87.58 C50.1939763,87.5997264 50.3863313,87.6210742 50.5770648,87.6440434 Z M35.9833156,99.3161857 C36.0268486,99.1662092 36.0752184,99.0179229 36.1283066,98.8715456 C36.0704176,98.9914308 36.024079,99.1041157 35.9896408,99.2087479 C35.9887473,99.2444057 35.9861875,99.2797301 35.9819612,99.3147213 C35.9824127,99.3152094 35.9828642,99.3156975 35.9833156,99.3161857 Z M35.9670582,99.2986147 C35.9687353,99.2872334 35.9704471,99.2758595 35.9721935,99.2644931 C35.9691775,99.2746701 35.9662813,99.284765 35.9635052,99.2947768 C35.9646896,99.296056 35.965874,99.2973354 35.9670582,99.2986147 Z';
	
	var Plant = function Plant(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 122 196'
	    }, props),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemPlant3x2.default })
	  );
	};
	
	Plant.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = Plant;
	module.exports = exports['default'];

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemPowerStrip3x = __webpack_require__(656);
	
	var _itemPowerStrip3x2 = _interopRequireDefault(_itemPowerStrip3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'M74.14,67.27 L74.14,71.95 L63.83,77.9 L21.11,53.24 L21.11,48.53 L31.39,42.59 L74.14,67.27 Z';
	
	var PowerStrip = function PowerStrip(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 74.14 84.9',
	      sparksTop: 91,
	      sparksLeft: 96
	    }, props),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemPowerStrip3x2.default })
	  );
	};
	
	PowerStrip.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = PowerStrip;
	module.exports = exports['default'];

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemRug3x = __webpack_require__(660);
	
	var _itemRug3x2 = _interopRequireDefault(_itemRug3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'M0,133.86 L231.38,0 L411.07,103.74 L411.07,106.36 L179.69,240.22 L0,136.48 L0,133.86 Z';
	
	var Rug = function Rug(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 412 241'
	    }, props),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemRug3x2.default })
	  );
	};
	
	Rug.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = Rug;
	module.exports = exports['default'];

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemSofa13x = __webpack_require__(663);
	
	var _itemSofa13x2 = _interopRequireDefault(_itemSofa13x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'M47.0421224,142.417727 C46.9357499,142.615512 46.7978174,142.798908 46.63,142.96 C45.95,143.49 44.8,142.96 44.8,142.96 C44.8,142.96 44.9514072,142.821362 45.1248881,142.636022 C44.7332215,142.684982 44.3749354,142.727982 44.0446926,142.753725 C43.7604285,143.005543 43.4077509,143.152071 42.94,143.02 C42.09,142.78 42.09,142.64 42.09,142.64 C42.09,142.64 42.1645763,142.617053 42.275107,142.578563 C42.0226108,142.4737 41.7893762,142.321525 41.5688244,142.108112 C40.8444347,142.377008 40.0187371,142.183182 39.49,141.6 C39.49,141.6 40.98,141.54 40.49,141.23 C40,140.92 38.57,140.94 38.08,140.53 C37.59,140.12 37.53,139.76 37.85,139.61 C38.6504504,139.665663 39.4439211,139.796234 40.22,140 C40.2511225,140.000915 40.2784745,139.998144 40.3020559,139.992223 C40.2304427,139.83088 40.1582111,139.662653 40.0854879,139.487895 C40.0279217,139.458564 39.9627591,139.432088 39.89,139.41 C39.33,139.24 38.89,139.07 38.89,139.07 C39.1452737,138.851701 39.466873,138.741764 39.7898958,138.748693 C39.3728639,137.665783 38.9455754,136.389527 38.5308772,134.983477 C38.32452,134.796805 38.175546,134.54944 38.11,134.27 C38.1915455,134.307812 38.2735607,134.344574 38.3560251,134.380278 C38.309856,134.218233 38.2638866,134.05466 38.2181497,133.889651 C38.1066557,133.862314 37.996568,133.832697 37.89,133.8 C37.4288324,133.691188 37.1073369,133.273661 37.12,132.8 C37.12,132.8 37.545099,132.964243 38.0249399,133.178772 C37.9584797,132.929386 37.8926265,132.677146 37.8274847,132.422345 C37.3756136,132.17031 36.9357606,131.909412 36.91,131.76 C36.869714,131.526341 37.1020858,131.331633 37.5495785,131.301411 C37.4134083,130.734755 37.2812851,130.158051 37.1542709,129.574253 L0,108.27 L74.94,65.15 L77.26,66.4805088 L77.26,64.44 L148.28,105.16 L137.05,111.43 L125.837927,104.95854 L83.8207891,129.138161 C83.8335687,129.393501 83.84,129.624877 83.84,129.83 C83.82,132.73 83.21,133.76 81.39,134.55 C79.867133,135.211959 75.4905191,136.373749 70.3190283,137.606556 C70.2397781,138.872484 69.6949992,140.094383 68.74,141.01 C67.13,142.26 64.42,141.01 64.42,141.01 C64.42,141.01 65.3126534,140.222882 65.8907565,139.456364 L60.15,142.76 L56.5122822,140.674133 C52.1903694,141.568235 48.5942875,142.240941 47.0421224,142.417727 Z M180.3232,74.2280175 L137.41,98.92 L77.26,64.44 L152.2,21.32 L155.156636,23.014843 C154.779081,19.0165899 154.318799,15.0252479 153.775919,11.0433882 L153.77507,11.0371604 C153.773381,11.0247735 153.771691,11.0123867 153.77,11 L154.208,10.7946667 L173.48,0 L256.79,47.7 L256.79,95.87 L237.08,106.91 L237.08,106.87 C237.08,106.87 204.195496,87.9880135 180.3232,74.2280175 Z';
	
	var Sofa1 = function Sofa1(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 257 144'
	    }, props),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemSofa13x2.default })
	  );
	};
	
	Sofa1.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = Sofa1;
	module.exports = exports['default'];

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IrregularInteraction = __webpack_require__(6);
	
	var _IrregularInteraction2 = _interopRequireDefault(_IrregularInteraction);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _itemSofa23x = __webpack_require__(664);
	
	var _itemSofa23x2 = _interopRequireDefault(_itemSofa23x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'M103.008787,167.046281 L83.31,178.08 C83.31,178.08 7.29,134.43 2.51,131.5 C3.06850884,115.028584 2.22883217,98.5394755 0,82.21 L19.71,71.17 L82.65,107.206946 L82.65,89.02 L236.52,0 L260.82,13.62 L260.82,80.24 L106.96,169.26 L103.008787,167.046281 Z';
	
	var Sofa2 = function Sofa2(props) {
	  return _react2.default.createElement(
	    _IrregularInteraction2.default,
	    _extends({
	      path: path,
	      preserveAspectRatio: 'xMidYMin meet',
	      viewBox: '0 0 257 144'
	    }, props),
	    _react2.default.createElement(_ItemImage2.default, { src: _itemSofa23x2.default })
	  );
	};
	
	Sofa2.propTypes = _IrregularInteraction2.default.propTypes;
	
	exports.default = Sofa2;
	module.exports = exports['default'];

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 65%;\n  '], ['\n    width: 65%;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAutomata = __webpack_require__(17);
	
	var _ButtonArrow = __webpack_require__(204);
	
	var _ButtonArrow2 = _interopRequireDefault(_ButtonArrow);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Item = __webpack_require__(13);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _characterKeoniNoSlippers3x = __webpack_require__(198);
	
	var _characterKeoniNoSlippers3x2 = _interopRequireDefault(_characterKeoniNoSlippers3x);
	
	var _characterPluggyForwardArmDown3x = __webpack_require__(46);
	
	var _characterPluggyForwardArmDown3x2 = _interopRequireDefault(_characterPluggyForwardArmDown3x);
	
	var _RoomLiving = __webpack_require__(427);
	
	var _RoomLiving2 = _interopRequireDefault(_RoomLiving);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var RoomContainer = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoomdesktop__RoomContainer'
	})(['align-items:center;display:flex;height:100%;justify-content:center;max-width:', 'px;position:relative;width:70%;z-index:2;transform:scale(0.75);@media (min-height:768px){transform:none;}', ';'], function (p) {
	  return p.theme.mediaSizes.extraLarge;
	}, _theme.media.greaterThan('large')(_templateObject));
	
	var TipWrapper = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoomdesktop__TipWrapper'
	})(['margin:0 auto;max-width:', 'px;width:100%;'], function (p) {
	  return p.theme.mediaSizes.small * 0.8;
	});
	
	var ItemAbove = (0, _styledComponents2.default)(_Item2.default).withConfig({
	  displayName: '_LivingRoomRoomdesktop__ItemAbove'
	})(['z-index:10;']);
	
	var NextRoomContainer = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoomdesktop__NextRoomContainer'
	})(['animation:', ' 2s infinite;animation-timing-function:cubic-bezier(0.455,0.03,0.515,0.955);align-items:center;bottom:', ';display:flex;flex-direction:column;justify-content:center;padding:0 ', ' ', ' 0;position:absolute;right:0;z-index:3;@media (min-height:900px) and (min-width:', 'px){bottom:', ';}'], function (p) {
	  return p.theme.animation.sideToSide;
	}, function (p) {
	  return p.theme.spacing(5);
	}, function (p) {
	  return p.theme.spacing(2);
	}, function (p) {
	  return p.theme.spacing(2);
	}, function (p) {
	  return p.theme.mediaSizes.medium;
	}, function (p) {
	  return p.theme.spacing(6);
	});
	
	var StyledButtonWide = (0, _styledComponents2.default)(_Button2.default).withConfig({
	  displayName: '_LivingRoomRoomdesktop__StyledButtonWide'
	})(['padding-left:', ';padding-right:', ';'], function (p) {
	  return p.theme.spacing(2.5);
	}, function (p) {
	  return p.theme.spacing(2.5);
	});
	
	var CharacterShadow = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoomdesktop__CharacterShadow'
	})(['background-color:rgba(0,0,0,0.15);border-radius:50%;bottom:0;height:15%;position:absolute;transform:translateY(25%);width:100%;z-index:-1;']);
	
	var LivingRoomRoomDesktop = function (_Component) {
	  _inherits(LivingRoomRoomDesktop, _Component);
	
	  function LivingRoomRoomDesktop() {
	    _classCallCheck(this, LivingRoomRoomDesktop);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LivingRoomRoomDesktop.prototype.render = function render() {
	    var _props = this.props,
	        animateIds = _props.animateIds,
	        clickedAllItems = _props.clickedAllItems,
	        onItemClick = _props.onItemClick,
	        pendingHighlightIds = _props.pendingHighlightIds,
	        renderTip = _props.renderTip,
	        successHighlightIds = _props.successHighlightIds,
	        onRoomClear = _props.onRoomClear,
	        roomProgressData = _props.roomProgressData,
	        buttonText = _props.buttonText;
	
	
	    return [clickedAllItems && _react2.default.createElement(
	      NextRoomContainer,
	      { key: 'living-room__room__next-room-container--desktop' },
	      _react2.default.createElement(StyledButtonWide, {
	        onClick: function onClick(event) {
	          return onRoomClear(event, roomProgressData);
	        },
	        size: 'large',
	        pulse: true,
	        to: '/kitchen',
	        buttonText: buttonText
	      })
	    ), _react2.default.createElement(
	      RoomContainer,
	      { key: 'living-room__room__room-container' },
	      _react2.default.createElement(
	        _RoomLiving2.default,
	        {
	          animateIds: animateIds,
	          pendingHighlightIds: pendingHighlightIds,
	          successHighlightIds: successHighlightIds,
	          onItemClick: onItemClick
	        },
	        _react2.default.createElement(
	          _Item2.default,
	          { width: 13, left: -8.75, bottom: 20.5 },
	          _react2.default.createElement(_ItemImage2.default, { src: _characterPluggyForwardArmDown3x2.default }),
	          _react2.default.createElement(CharacterShadow, null)
	        ),
	        _react2.default.createElement(
	          _Item2.default,
	          { width: 12, left: 94, bottom: 19.5 },
	          _react2.default.createElement(_ItemImage2.default, { src: _characterKeoniNoSlippers3x2.default }),
	          _react2.default.createElement(CharacterShadow, null)
	        ),
	        _react2.default.createElement(
	          ItemAbove,
	          { left: 81.3, bottom: 50, width: 37.5 },
	          _react2.default.createElement(
	            TipWrapper,
	            null,
	            clickedAllItems && renderTip('living-room__conclusion', {
	              character: false,
	              closable: false
	            })
	          )
	        ),
	        _react2.default.createElement(
	          ItemAbove,
	          { left: -24.9, bottom: 50, width: 45.5 },
	          _react2.default.createElement(
	            TipWrapper,
	            null,
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'guide' },
	              renderTip('living-room__guide', { character: false })
	            ),
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'entertainmentSystem' },
	              renderTip('living-room__entertainmentSystem', {
	                character: false
	              })
	            ),
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'blinds' },
	              renderTip('living-room__blinds', { character: false })
	            ),
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'ac' },
	              renderTip('living-room__ac', { character: false })
	            ),
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'powerStrip' },
	              renderTip('living-room__powerStrip', {
	                character: false
	              })
	            ),
	            _react2.default.createElement(
	              _reactAutomata.State,
	              { value: 'chloe' },
	              renderTip('living-room__chloe', {
	                character: false
	              })
	            )
	          )
	        )
	      )
	    )];
	  };
	
	  return LivingRoomRoomDesktop;
	}(_react.Component);
	
	LivingRoomRoomDesktop.propTypes = {
	  pendingHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  successHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  onItemClick: _propTypes2.default.func.isRequired,
	  clickedAllItems: _propTypes2.default.bool
	};
	LivingRoomRoomDesktop.defaultPropTypes = {
	  clickedAllItems: false
	};
	exports.default = LivingRoomRoomDesktop;
	module.exports = exports['default'];

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAutomata = __webpack_require__(17);
	
	var _Hammer = __webpack_require__(94);
	
	var _Hammer2 = _interopRequireDefault(_Hammer);
	
	var _Item = __webpack_require__(13);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _characterKeoniForward3x = __webpack_require__(68);
	
	var _characterKeoniForward3x2 = _interopRequireDefault(_characterKeoniForward3x);
	
	var _characterPluggyForward3x = __webpack_require__(128);
	
	var _characterPluggyForward3x2 = _interopRequireDefault(_characterPluggyForward3x);
	
	var _RoomLiving = __webpack_require__(427);
	
	var _RoomLiving2 = _interopRequireDefault(_RoomLiving);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyledHammer = (0, _styledComponents2.default)(_Hammer2.default).withConfig({
	  displayName: '_LivingRoomRoommobile__StyledHammer'
	})(['height:100%;width:100%;position:absolute;top:0;left:0;']);
	
	var StyledRoomLiving = (0, _styledComponents2.default)(_RoomLiving2.default).attrs({
	  style: function style(p) {
	    return {
	      width: p.scale * 100 + 'vmin',
	      transform: 'translate3d(calc(-25% + ' + p.x + 'px), calc(-50% + ' + p.y + 'px), 0)'
	    };
	  }
	}).withConfig({
	  displayName: '_LivingRoomRoommobile__StyledRoomLiving'
	})(['left:50%;position:absolute;top:50%;']);
	
	var TipContainer = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoommobile__TipContainer'
	})(['display:flex;flex-direction:column;height:100%;justify-content:center;left:0;padding:', ' ', ' ', ';pointer-events:none;position:fixed;top:0;width:100%;z-index:4;'], function (p) {
	  return p.theme.spacing(4);
	}, function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(5);
	});
	
	var TipBackground = _styledComponents2.default.div.withConfig({
	  displayName: '_LivingRoomRoommobile__TipBackground'
	})(['background-color:', ';height:100%;left:0;pointer-events:', ';position:absolute;top:0;width:100%;z-index:1;'], function (p) {
	  return p.block ? 'rgba(0, 0, 0, 0.6)' : 'transparent';
	}, function (p) {
	  return p.block ? 'auto' : 'none';
	});
	
	var LivingRoomRoomMobile = function (_Component) {
	  _inherits(LivingRoomRoomMobile, _Component);
	
	  function LivingRoomRoomMobile() {
	    _classCallCheck(this, LivingRoomRoomMobile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LivingRoomRoomMobile.prototype.render = function render() {
	    var _props = this.props,
	        animateIds = _props.animateIds,
	        clickedAllItems = _props.clickedAllItems,
	        onItemClick = _props.onItemClick,
	        pendingHighlightIds = _props.pendingHighlightIds,
	        renderTip = _props.renderTip,
	        shouldBlock = _props.shouldBlock,
	        successHighlightIds = _props.successHighlightIds,
	        transition = _props.transition,
	        onRoomClear = _props.onRoomClear,
	        roomProgressData = _props.roomProgressData,
	        buttonText = _props.buttonText;
	
	
	    return [_react2.default.createElement(
	      TipContainer,
	      { key: 'living-room__room__tip-container--mobile' },
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'items' },
	        clickedAllItems && renderTip('living-room__conclusion', {
	          character: 'keoni',
	          closeButtonText: buttonText,
	          closeType: 'button',
	          onClose: function onClose(event) {
	            return onRoomClear(event, roomProgressData);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'guide' },
	        renderTip('living-room__guide--mobile')
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'entertainmentSystem' },
	        renderTip('living-room__entertainmentSystem')
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'blinds' },
	        renderTip('living-room__blinds')
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'ac' },
	        renderTip('living-room__ac')
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'powerStrip' },
	        renderTip('living-room__powerStrip')
	      ),
	      _react2.default.createElement(
	        _reactAutomata.State,
	        { value: 'chloe' },
	        renderTip('living-room__chloe')
	      )
	    ), _react2.default.createElement(TipBackground, {
	      block: shouldBlock,
	      onClick: function onClick() {
	        return transition('NEXT');
	      },
	      key: 'living-room__room__tip-background--mobile'
	    }), _react2.default.createElement(
	      StyledHammer,
	      { initialScale: 1.5, key: 'living-room__room__hammer--mobile' },
	      function (x, y, scale) {
	        return _react2.default.createElement(StyledRoomLiving, {
	          animateIds: animateIds,
	          dropChildrenMotion: false,
	          onItemClick: onItemClick,
	          pendingHighlightIds: pendingHighlightIds,
	          scale: scale,
	          successHighlightIds: successHighlightIds,
	          x: x,
	          y: y
	        });
	      }
	    )];
	  };
	
	  return LivingRoomRoomMobile;
	}(_react.Component);
	
	LivingRoomRoomMobile.propTypes = {
	  pendingHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  successHighlightIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  onItemClick: _propTypes2.default.func.isRequired,
	  clickedAllItems: _propTypes2.default.bool
	};
	LivingRoomRoomMobile.defaultPropTypes = {
	  clickedAllItems: false
	};
	exports.default = LivingRoomRoomMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Desktop = __webpack_require__(86);
	
	var _Desktop2 = _interopRequireDefault(_Desktop);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledDesktop = (0, _styledComponents2.default)(_Desktop2.default).withConfig({
	  displayName: '_StyledDesktop__StyledDesktop'
	})(['align-items:center;height:100%;justify-content:center;width:100%;', ';'], _theme.media.greaterThan('medium')(_templateObject));
	
	exports.default = StyledDesktop;
	module.exports = exports['default'];

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Footer = __webpack_require__(65);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledFooter = (0, _styledComponents2.default)(_Footer2.default).withConfig({
	  displayName: '_StyledFooter__StyledFooter'
	})(['background:linear-gradient(to right,#3b8e64,#103027);bottom:0;display:flex;left:0;position:fixed;right:0;z-index:1;']);
	
	exports.default = StyledFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Mobile = __webpack_require__(87);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledMobile = (0, _styledComponents2.default)(_Mobile2.default).withConfig({
	  displayName: '_StyledMobile__StyledMobile'
	})(['align-items:center;display:flex;height:100%;justify-content:center;', ';'], _theme.media.greaterThan('medium')(_templateObject));
	
	exports.default = StyledMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 25%;\n  '], ['\n    width: 25%;\n  ']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PreloadBar = __webpack_require__(95);
	
	var _PreloadBar2 = _interopRequireDefault(_PreloadBar);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledPreloadBar = (0, _styledComponents2.default)(_PreloadBar2.default).withConfig({
	  displayName: '_StyledPreloadBar__StyledPreloadBar'
	})(['left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:50%;', ';'], _theme.media.greaterThan('medium')(_templateObject));
	
	exports.default = StyledPreloadBar;
	module.exports = exports['default'];

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _TipTracker = __webpack_require__(99);
	
	var _TipTracker2 = _interopRequireDefault(_TipTracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledTipTracker = (0, _styledComponents2.default)(_TipTracker2.default).withConfig({
	  displayName: '_StyledTipTracker__StyledTipTracker'
	})(['left:0;position:fixed;right:0;top:0;z-index:3;']);
	
	exports.default = StyledTipTracker;
	module.exports = exports['default'];

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(9);
	
	var _gameProgress = __webpack_require__(12);
	
	var _quizzes = __webpack_require__(41);
	
	var _reactAutomata = __webpack_require__(17);
	
	var _itemInteractions = __webpack_require__(25);
	
	var _helpers = __webpack_require__(40);
	
	var _AudioProvider = __webpack_require__(48);
	
	var _Preload = __webpack_require__(88);
	
	var _Preload2 = _interopRequireDefault(_Preload);
	
	var _RoomPageBase2 = __webpack_require__(98);
	
	var _RoomPageBase3 = _interopRequireDefault(_RoomPageBase2);
	
	var _LivingRoomRoom = __webpack_require__(879);
	
	var _LivingRoomRoom2 = _interopRequireDefault(_LivingRoomRoom);
	
	var _LivingRoomRoom3 = __webpack_require__(880);
	
	var _LivingRoomRoom4 = _interopRequireDefault(_LivingRoomRoom3);
	
	var _StyledDesktop = __webpack_require__(881);
	
	var _StyledDesktop2 = _interopRequireDefault(_StyledDesktop);
	
	var _StyledMobile = __webpack_require__(883);
	
	var _StyledMobile2 = _interopRequireDefault(_StyledMobile);
	
	var _StyledPreloadBar = __webpack_require__(884);
	
	var _StyledPreloadBar2 = _interopRequireDefault(_StyledPreloadBar);
	
	var _StyledTipTracker = __webpack_require__(885);
	
	var _StyledTipTracker2 = _interopRequireDefault(_StyledTipTracker);
	
	var _StyledFooter = __webpack_require__(882);
	
	var _StyledFooter2 = _interopRequireDefault(_StyledFooter);
	
	var _characterKeoniForward3x = __webpack_require__(68);
	
	var _characterKeoniForward3x2 = _interopRequireDefault(_characterKeoniForward3x);
	
	var _characterPluggyForward3x = __webpack_require__(128);
	
	var _characterPluggyForward3x2 = _interopRequireDefault(_characterPluggyForward3x);
	
	var _floorWood3x = __webpack_require__(200);
	
	var _floorWood3x2 = _interopRequireDefault(_floorWood3x);
	
	var _indicatorArrowDown3x = __webpack_require__(47);
	
	var _indicatorArrowDown3x2 = _interopRequireDefault(_indicatorArrowDown3x);
	
	var _itemAcF13x = __webpack_require__(619);
	
	var _itemAcF13x2 = _interopRequireDefault(_itemAcF13x);
	
	var _itemAcF23x = __webpack_require__(620);
	
	var _itemAcF23x2 = _interopRequireDefault(_itemAcF23x);
	
	var _itemAcF33x = __webpack_require__(621);
	
	var _itemAcF33x2 = _interopRequireDefault(_itemAcF33x);
	
	var _itemAcF43x = __webpack_require__(622);
	
	var _itemAcF43x2 = _interopRequireDefault(_itemAcF43x);
	
	var _itemAcF53x = __webpack_require__(623);
	
	var _itemAcF53x2 = _interopRequireDefault(_itemAcF53x);
	
	var _itemAcF63x = __webpack_require__(624);
	
	var _itemAcF63x2 = _interopRequireDefault(_itemAcF63x);
	
	var _itemAcF73x = __webpack_require__(625);
	
	var _itemAcF73x2 = _interopRequireDefault(_itemAcF73x);
	
	var _itemAcF83x = __webpack_require__(626);
	
	var _itemAcF83x2 = _interopRequireDefault(_itemAcF83x);
	
	var _itemAcF93x = __webpack_require__(627);
	
	var _itemAcF93x2 = _interopRequireDefault(_itemAcF93x);
	
	var _itemBlindsF13x = __webpack_require__(628);
	
	var _itemBlindsF13x2 = _interopRequireDefault(_itemBlindsF13x);
	
	var _itemBlindsF23x = __webpack_require__(629);
	
	var _itemBlindsF23x2 = _interopRequireDefault(_itemBlindsF23x);
	
	var _itemBlindsF33x = __webpack_require__(630);
	
	var _itemBlindsF33x2 = _interopRequireDefault(_itemBlindsF33x);
	
	var _itemBlindsF43x = __webpack_require__(631);
	
	var _itemBlindsF43x2 = _interopRequireDefault(_itemBlindsF43x);
	
	var _itemBlindsF53x = __webpack_require__(632);
	
	var _itemBlindsF53x2 = _interopRequireDefault(_itemBlindsF53x);
	
	var _itemChloeF13x = __webpack_require__(635);
	
	var _itemChloeF13x2 = _interopRequireDefault(_itemChloeF13x);
	
	var _itemChloeF23x = __webpack_require__(636);
	
	var _itemChloeF23x2 = _interopRequireDefault(_itemChloeF23x);
	
	var _itemChloeF33x = __webpack_require__(637);
	
	var _itemChloeF33x2 = _interopRequireDefault(_itemChloeF33x);
	
	var _itemChloeF43x = __webpack_require__(638);
	
	var _itemChloeF43x2 = _interopRequireDefault(_itemChloeF43x);
	
	var _itemChloeF53x = __webpack_require__(639);
	
	var _itemChloeF53x2 = _interopRequireDefault(_itemChloeF53x);
	
	var _itemChloeF63x = __webpack_require__(640);
	
	var _itemChloeF63x2 = _interopRequireDefault(_itemChloeF63x);
	
	var _itemChloeF73x = __webpack_require__(641);
	
	var _itemChloeF73x2 = _interopRequireDefault(_itemChloeF73x);
	
	var _itemEntertainmentSystem3x = __webpack_require__(643);
	
	var _itemEntertainmentSystem3x2 = _interopRequireDefault(_itemEntertainmentSystem3x);
	
	var _itemPlant3x = __webpack_require__(655);
	
	var _itemPlant3x2 = _interopRequireDefault(_itemPlant3x);
	
	var _itemPowerStrip3x = __webpack_require__(656);
	
	var _itemPowerStrip3x2 = _interopRequireDefault(_itemPowerStrip3x);
	
	var _itemRug3x = __webpack_require__(660);
	
	var _itemRug3x2 = _interopRequireDefault(_itemRug3x);
	
	var _itemSofa13x = __webpack_require__(663);
	
	var _itemSofa13x2 = _interopRequireDefault(_itemSofa13x);
	
	var _itemSofa23x = __webpack_require__(664);
	
	var _itemSofa23x2 = _interopRequireDefault(_itemSofa23x);
	
	var _wallsGreen3x = __webpack_require__(709);
	
	var _wallsGreen3x2 = _interopRequireDefault(_wallsGreen3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* @meta
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               layout: room-green
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	// Preload items
	
	
	var preloadItems = [_characterKeoniForward3x2.default, _characterPluggyForward3x2.default, _floorWood3x2.default, _indicatorArrowDown3x2.default, _itemAcF13x2.default, _itemAcF23x2.default, _itemAcF33x2.default, _itemAcF43x2.default, _itemAcF53x2.default, _itemAcF63x2.default, _itemAcF73x2.default, _itemAcF83x2.default, _itemAcF93x2.default, _itemBlindsF13x2.default, _itemBlindsF23x2.default, _itemBlindsF33x2.default, _itemBlindsF43x2.default, _itemBlindsF53x2.default, _itemChloeF13x2.default, _itemChloeF23x2.default, _itemChloeF33x2.default, _itemChloeF43x2.default, _itemChloeF53x2.default, _itemChloeF63x2.default, _itemChloeF73x2.default, _itemEntertainmentSystem3x2.default, _itemPlant3x2.default, _itemPowerStrip3x2.default, _itemRug3x2.default, _itemSofa13x2.default, _itemSofa23x2.default, _wallsGreen3x2.default];
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    firstName: state.player.firstName,
	    clickedItems: state.itemInteractions.clickedItems,
	    roomsCleared: state.gameProgress.roomsCleared,
	    gameFinished: state.gameProgress.gameFinished,
	    modalIsActive: state.gameProgress.modalIsActive,
	    isOver18: state.player.isOver18,
	    clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    clickItem: _itemInteractions.clickItem,
	    removeItemsForRoom: _itemInteractions.removeItemsForRoom,
	    setRoomsCleared: _gameProgress.setRoomsCleared,
	    setGameFinished: _gameProgress.setGameFinished,
	    setModalStatus: _gameProgress.setModalStatus,
	    setSelectedRoom: _gameProgress.setSelectedRoom,
	    setStartButtonUrl: _gameProgress.setStartButtonUrl,
	    openQuizModal: _quizzes.openQuizModal
	  }, dispatch);
	};
	
	var statechart = {
	  initial: 'init',
	  states: {
	    init: {
	      on: {
	        NEXT: 'guide'
	      }
	    },
	
	    guide: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	
	    items: {
	      on: {
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	
	    ac: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	    blinds: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	    entertainmentSystem: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	    powerStrip: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    },
	
	    // Easter egg
	    chloe: {
	      on: {
	        NEXT: 'items',
	        AC: 'ac',
	        BLINDS: 'blinds',
	        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
	        POWER_STRIP: 'powerStrip',
	        CHLOE: 'chloe'
	      }
	    }
	  }
	};
	
	var LivingRoomPage = function (_RoomPageBase) {
	  _inherits(LivingRoomPage, _RoomPageBase);
	
	  function LivingRoomPage() {
	    _classCallCheck(this, LivingRoomPage);
	
	    return _possibleConstructorReturn(this, _RoomPageBase.apply(this, arguments));
	  }
	
	  LivingRoomPage.prototype.componentDidMount = function componentDidMount() {
	    _RoomPageBase3.default.prototype.componentDidMount.bind(this)();
	    this.props.removeItemsForRoom(this.constructor.roomId);
	  };
	
	  LivingRoomPage.prototype.onPreloadLoaded = function onPreloadLoaded() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.props.transition('NEXT');
	    }, 1000);
	  };
	
	  LivingRoomPage.prototype.onItemClick = function onItemClick(id) {
	    var _this3 = this;
	
	    var fullItemId = this.constructor.roomId + '__' + id;
	
	    var playSound = function playSound() {
	      if (!_this3.props.clickedItems.includes(fullItemId)) {
	        _this3.props.audio.xyl1.play();
	      }
	    };
	
	    var machineState = this.props.machineState;
	
	    switch (machineState) {
	      // case 'guide':
	      // case 'itemsLimited':
	      //   if (id === 'powerStrip') {
	      //     super.onItemClick(id)
	      //     if (this.constructor.validItems.includes(id)) playSound()
	      //   }
	      //   break
	
	      default:
	        _RoomPageBase.prototype.onItemClick.call(this, id);
	        if (this.constructor.validItems.includes(id)) playSound();
	        break;
	    }
	  };
	
	  LivingRoomPage.prototype.getPendingHighlightIds = function getPendingHighlightIds() {
	    var machineState = this.props.machineState;
	
	
	    switch (machineState) {
	      // case 'init':
	      // case 'guide':
	      // case 'itemsLimited':
	      //   return ['powerStrip']
	
	      default:
	        {
	          var clickedItems = this.getClickedItemsForRoom();
	
	          return this.constructor.validItems.filter(function (item) {
	            return !clickedItems.includes(item);
	          });
	        }
	    }
	  };
	
	  LivingRoomPage.prototype.getSuccessHighlightIds = function getSuccessHighlightIds() {
	    return this.getClickedItemsForRoom();
	  };
	
	  LivingRoomPage.prototype.getAnimateIds = function getAnimateIds() {
	    var machineState = this.props.machineState;
	
	
	    switch (machineState) {
	      case 'blinds':
	        return ['blinds'];
	
	      default:
	        return [];
	    }
	  };
	
	  LivingRoomPage.prototype.shouldBlock = function shouldBlock() {
	    var machineState = this.props.machineState;
	
	
	    switch (machineState) {
	      case 'items':
	        return this.clickedAllItems();
	
	      case 'guide':
	      case 'ac':
	      case 'blinds':
	      case 'entertainmentSystem':
	      case 'powerStrip':
	      case 'chloe':
	        return true;
	    }
	  };
	
	  LivingRoomPage.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        transition = _props.transition,
	        roomsCleared = _props.roomsCleared,
	        modalIsActive = _props.modalIsActive,
	        setGameFinished = _props.setGameFinished,
	        setModalStatus = _props.setModalStatus,
	        setRoomsCleared = _props.setRoomsCleared,
	        gameFinished = _props.gameFinished,
	        setSelectedRoom = _props.setSelectedRoom,
	        setStartButtonUrl = _props.setStartButtonUrl,
	        isOver18 = _props.isOver18,
	        openQuizModal = _props.openQuizModal,
	        clearedQuizRoomIds = _props.clearedQuizRoomIds;
	
	    var pendingHighlightIds = this.getPendingHighlightIds();
	    var successHighlightIds = this.getSuccessHighlightIds();
	    var animateIds = this.getAnimateIds();
	    var roomProgressData = {
	      roomId: 'living-room',
	      roomsCleared: roomsCleared,
	      modalIsActive: modalIsActive,
	      setGameFinished: setGameFinished,
	      setModalStatus: setModalStatus,
	      setRoomsCleared: setRoomsCleared,
	      gameFinished: gameFinished,
	      setSelectedRoom: setSelectedRoom,
	      setStartButtonUrl: setStartButtonUrl,
	      isOver18: isOver18,
	      openQuizModal: openQuizModal,
	      clearedQuizRoomIds: clearedQuizRoomIds
	    };
	    var buttonText = (0, _helpers.getRoomButtonText)();
	
	    return [_react2.default.createElement(_StyledTipTracker2.default, {
	      openedTipsCount: this.getOpenedTipsCount(),
	      roomName: this.constructor.roomName,
	      tipsCount: this.constructor.tipsCount,
	      key: 'living-room__tip-tracker',
	      isOver18: isOver18,
	      shakasEarned: clearedQuizRoomIds.length,
	      colorScheme: 'green'
	    }), _react2.default.createElement(_StyledFooter2.default, {
	      key: 'living-room__footer',
	      roomName: this.constructor.roomName
	    }), _react2.default.createElement(
	      _Preload2.default,
	      {
	        items: preloadItems,
	        onLoaded: this.onPreloadLoaded.bind(this),
	        key: 'living-room__preload'
	      },
	      function (loaded, percentDone) {
	        return loaded ? [_react2.default.createElement(
	          _StyledMobile2.default,
	          { key: 'living-room__mobile' },
	          _react2.default.createElement(_LivingRoomRoom4.default, {
	            animateIds: animateIds,
	            clickedAllItems: _this4.clickedAllItems(),
	            data: data,
	            onItemClick: _this4.onItemClick.bind(_this4),
	            pendingHighlightIds: pendingHighlightIds,
	            renderTip: _this4.renderTip.bind(_this4),
	            shouldBlock: _this4.shouldBlock(),
	            successHighlightIds: successHighlightIds,
	            transition: transition,
	            onRoomClear: _this4.onRoomClear,
	            roomProgressData: roomProgressData,
	            buttonText: buttonText
	          })
	        ), _react2.default.createElement(
	          _StyledDesktop2.default,
	          { key: 'living-room__desktop' },
	          _react2.default.createElement(_LivingRoomRoom2.default, {
	            animateIds: animateIds,
	            clickedAllItems: _this4.clickedAllItems(),
	            data: data,
	            onItemClick: _this4.onItemClick.bind(_this4),
	            pendingHighlightIds: pendingHighlightIds,
	            renderTip: _this4.renderTip.bind(_this4),
	            shouldBlock: _this4.shouldBlock(),
	            successHighlightIds: successHighlightIds,
	            transition: transition,
	            onRoomClear: _this4.onRoomClear,
	            roomProgressData: roomProgressData,
	            buttonText: buttonText
	          })
	        )] : _react2.default.createElement(_StyledPreloadBar2.default, { percentDone: percentDone, colorScheme: 'green' });
	      }
	    )];
	  };
	
	  return LivingRoomPage;
	}(_RoomPageBase3.default);
	
	LivingRoomPage.roomName = 'Living Room';
	LivingRoomPage.roomId = 'living-room';
	LivingRoomPage.validItems = ['entertainmentSystem', 'blinds', 'ac', 'powerStrip'];
	LivingRoomPage.tipsCount = 4;
	
	
	var LivingRoomPageConnected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _AudioProvider.connectAudio)()((0, _reactAutomata.withStatechart)(statechart)(LivingRoomPage)));
	
	exports.default = LivingRoomPageConnected;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-living-room-index-js-6a0a50a5aba22c710fd8.js